@use "variables" as *;

.mainDiv {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background-image: url(../../images/login_background.png);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.mainContent {
  display: flex;
  flex-direction: column;
  max-width: 380px;
  height: 100%;
}

.logoImage {
  width: 150px;
  filter: drop-shadow(2px 2px 2px #222);
  align-self: center;
  margin-top: $spacing-g;
}

.title {
  color: white;
  text-align: center;
  padding-top: $spacing-m;
}

.subtitle {
  font-size: $fontSize-l;
  color: white;
  text-align: center;
  white-space: pre-wrap;
}

.text {
  color: white;
  text-align: center;
  font-size: $fontSize-m;
}

.footer {
  color: lightgrey;
  text-align: center;
  font-size: $fontSize-m;
  margin-bottom: $spacing-l;
}

.backButton {
  margin-top: $spacing-xl;
  align-self: center;
}

.googleButton {
  width: 200px;
  height: auto;
}

.appleButton {
  width: 168px;
  height: auto;
}
